import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import KycTable from './Kyc_table';
import { Button, Grid, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect } from 'react';
import { fetchStates } from 'API/AgentOnboarding/api';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

export default function VerticalTabs() {
  const [value, setValue] = React.useState(0);

  const [SearchFilter, setSearchFilter] = useState({ name: '', agcode: '', state: '', district: '' });
  const [StateList, setStateList] = useState(null);
  const [Callback, setCallback] = useState({});

  const handleFilterchange = (name, value) => {
    if (name === 'name' && /^[a-zA-Z\s]*$/.test(value)) {
      setSearchFilter({ ...SearchFilter, [name]: value });
    }
    if (name === 'agcode' && /^[a-zA-Z0-9]*$/.test(value)) {
      setSearchFilter({ ...SearchFilter, [name]: value });
    }
    else if(name!=="name"&&name!=="agcode"){
      setSearchFilter({ ...SearchFilter, [name]: value });
    }
  };

  useEffect(() => {
    fetchStates(setStateList);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleFilterClear = () => {
    setSearchFilter({ name: '', agcode: '', state: '', district: '' });
    Callback.function({ name: '', agcode: '', state: '', district: '' });
  };

  const HandleSearch = () => {
    if (Callback.function) {
      Callback.function(SearchFilter);
    }
  };

  console.log('Callback', Callback);

  return (
    <Grid container>
      <Grid container mb={1} spacing={2} alignItems="center">
        <Grid item xl={2} lg={2} md={6} sm={6}>
          <TextField
            id="outlined-basic"
            label="Name"
            size="small"
            value={SearchFilter.name}
            fullWidth
            onChange={(e) => handleFilterchange('name', e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            variant="outlined"
          />
        </Grid>
        <Grid item xl={2} lg={2} md={6} sm={6}>
          <TextField
            id="outlined-basic"
            label="Agent code"
            size="small"
            value={SearchFilter.agcode}
            fullWidth
            onChange={(e) => handleFilterchange('agcode', e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            variant="outlined"
          />
        </Grid>
        <Grid item xl={2} lg={2} md={6} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label">State</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={SearchFilter.state}
              label="State"
              onChange={(e) => handleFilterchange('state', e.target.value)}
            >
              {StateList ? (
                Object.keys(StateList).map((state) => (
                  <MenuItem key={state} value={state}>
                    {state}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value={''}>Loading</MenuItem>
              )}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={2} lg={2} md={6} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label">District</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={SearchFilter.district}
              label="District"
              onChange={(e) => handleFilterchange('district', e.target.value)}
            >
              {SearchFilter.state && StateList[SearchFilter.state] ? (
                StateList[SearchFilter.state].map((district) => (
                  <MenuItem key={district} value={district}>
                    {district}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value={''}>Select state first</MenuItem>
              )}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={2} lg={2} md={6} sm={6}>
          <Button variant="contained" fullWidth onClick={() => HandleSearch()}>
            Search
          </Button>
        </Grid>
        <Grid item xl={2} lg={2} md={6} sm={6}>
          <Button variant="outlined" fullWidth onClick={() => handleFilterClear()}>
            clear
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: '66.5vh', width: '100%' }}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          indicatorColor="secondary"
          textColor="secondary"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderRight: 1, borderColor: 'divider', width: '15%' }}
        >
          <Tab label="Pending" {...a11yProps(0)} />
          <Tab label="Approved" {...a11yProps(1)} />
          <Tab label="Rejected" {...a11yProps(2)} />
        </Tabs>
        <div style={{ width: '85%' }}>
          <TabPanel value={value} index={0} sx={{ width: '100%' }}>
            <KycTable sx={{ width: '100vw' }} 
              type={'pending'} 
              filter={SearchFilter} 
              setCallback={setCallback} />
          </TabPanel>
          <TabPanel value={value} index={1} sx={{ width: '100%' }}>
            <KycTable 
              sx={{ width: '100vw' }} 
              type={'approved'} 
              filter={SearchFilter} 
              setCallback={setCallback} />
          </TabPanel>
          <TabPanel value={value} index={2} sx={{ width: '100%' }}>
            <KycTable 
              sx={{ width: '100vw' }} 
              type={'rejected'} 
              filter={SearchFilter} 
              setCallback={setCallback} />
          </TabPanel>
        </div>
      </Box>
    </Grid>
  );
}
